// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 769px) {
  ._36gpzn0 {
    width: 31%;
    max-width: 360px;
    float: left;
  }
  ._36gpzn1 {
    max-width: 1200px;
    width: calc(100% - 80px);
  }
  ._36gpzn2 {
    width: calc(69% - 20px);
    float: right;
  }
  ._36gpzn3 {
    font-size: 48px;
    line-height: 1.6em;
  }
}
@media screen and (max-width: 768px) {
  ._36gpzn0 {
    float: none;
    width: 100%;
  }
  ._36gpzn1 {
    width: 100%;
    padding: 0px;
    margin: 0px;
  }
  ._36gpzn2 {
    float: none;
    width: 100%;
  }
  ._36gpzn3 {
    font-size: 26px;
    line-height: 1.6em;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;AACA;EACE;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":["@media screen and (min-width: 769px) {\n  ._36gpzn0 {\n    width: 31%;\n    max-width: 360px;\n    float: left;\n  }\n  ._36gpzn1 {\n    max-width: 1200px;\n    width: calc(100% - 80px);\n  }\n  ._36gpzn2 {\n    width: calc(69% - 20px);\n    float: right;\n  }\n  ._36gpzn3 {\n    font-size: 48px;\n    line-height: 1.6em;\n  }\n}\n@media screen and (max-width: 768px) {\n  ._36gpzn0 {\n    float: none;\n    width: 100%;\n  }\n  ._36gpzn1 {\n    width: 100%;\n    padding: 0px;\n    margin: 0px;\n  }\n  ._36gpzn2 {\n    float: none;\n    width: 100%;\n  }\n  ._36gpzn3 {\n    font-size: 26px;\n    line-height: 1.6em;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
